import { ClipboardList } from 'lucide-react'
import CardDateHistory from '../CardDateHistory'

export default function CardActionsPanel({
    t,
    completionFields,
    normalizedCompletionPayload,
    members,
    displayedKpiUserId,
    currentUserId,
    displayCompletionKpis,
    canEditKpis,
    onChangeKpiValue,
    cardId,
    userId,
    isAdmin,
}) {
    const byUser = normalizedCompletionPayload.by_user || {}

    return (
        <>
            {completionFields.length > 0 && (() => {
                const completedCount = members.filter((member) => {
                    const value = byUser[member.id]?.values
                    if (!value) return false
                    return completionFields.every((field) => String(value[field.key] ?? '').trim() !== '')
                }).length
                const totalCount = members.length || 1
                const allDone = completedCount === totalCount && totalCount > 0

                return (
                    <div className="cd-kpi-summary">
                        <div className="cd-kpi-summary-header">
                            <ClipboardList size={16} />
                            <span>{t('card.kpi.heading')}</span>
                            <span
                                className={`cd-kpi-summary-badge ${allDone ? 'all-done' : 'partial'}`}
                                title={t('card.kpi.completedByCount', { defaultValue: `${completedCount} / ${totalCount} angajați au completat` })}
                                style={{
                                    marginLeft: 'auto',
                                    fontSize: 11,
                                    padding: '2px 8px',
                                    borderRadius: 999,
                                    background: allDone ? 'rgba(34,197,94,0.15)' : 'rgba(148,163,184,0.15)',
                                    color: allDone ? 'var(--accent-green, #16a34a)' : 'var(--text-secondary)',
                                }}
                            >
                                {allDone ? '✓ ' : ''}{completedCount}/{totalCount}
                            </span>
                        </div>
                        <div className="cd-kpi-summary-list">
                            {completionFields.map((field) => {
                                const currentValue = displayCompletionKpis?.[field.key]
                                const filled = String(currentValue ?? '').trim() !== ''
                                const editable = canEditKpis && displayedKpiUserId === currentUserId
                                return (
                                    <div key={field.key} className="cd-kpi-summary-item">
                                        <span className="cd-kpi-summary-label">{field.label}</span>
                                        {editable ? (
                                            <input
                                                className="cd-kpi-summary-input"
                                                type="number"
                                                min="0"
                                                step="1"
                                                inputMode="numeric"
                                                value={currentValue ?? ''}
                                                onChange={(event) => onChangeKpiValue(field.key, event.target.value)}
                                                aria-label={field.label}
                                            />
                                        ) : (
                                        <span
                                            className={`cd-kpi-summary-value ${filled ? 'filled' : ''}`.trim()}
                                            style={filled ? {
                                                color: 'var(--accent-green, #16a34a)',
                                                fontWeight: 600,
                                            } : undefined}
                                        >
                                                {filled ? `✓ ${currentValue}` : null}
                                        </span>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )
            })()}

            <div className="card-detail-sidebar-section cd-sidebar-history">
                <CardDateHistory cardId={cardId} userId={userId} isAdmin={isAdmin} />
            </div>
        </>
    )
}
